export const INPUT_BORDER_COLOR = "#8c8c8c"; //#dadada
export const WHITE_COLOR = "#FFFFFF";

export const TD_PRIMARY_GREEN = "#008A00";
